module.exports = __webpack_public_path__ + "static/Ubuntu-Light-277289c53af7cb469c1dc5dca3adca35.ttf";